import { FC, useEffect, useState } from 'react';
import { useEditElcMeetingActionItemStatusMutation } from 'redux/apiSlice/elcs.slice';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { TRtkErrorType } from 'data/types/generic.types';
import { Col, Row, useTranslation } from '@packages/utils';
import { EIconNames, Icon } from 'components/Base/Icon';
import { useTheme } from 'styled-components';
import { Tooltip } from 'components/Base/Tooltip';
import { TActionItemStatusProps } from './ActionItemStatus.types';

const ActionItemStatus: FC<TActionItemStatusProps> = ({
  id,
  status,
  isNew,
  setNewRowData,
  elcId,
  meetingId,
  actionPlanTaskId,
}) => {
  const theme = useTheme();
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.meetings-tab.details.action-items.table.editable-cell.status',
  });
  const { showToastNotification } = useShowToastNotification();

  const [value, setValue] = useState(!!status);

  useEffect(() => {
    if (status === undefined) return;
    setValue(status);
  }, [status]);

  const [updateStatus, { isLoading }] =
    useEditElcMeetingActionItemStatusMutation();

  const onUpdateStatus = async (val: boolean) => {
    if (isLoading || actionPlanTaskId) return;
    if (isNew) {
      setValue(val);
      setNewRowData(prev => ({ ...prev, status: val }));
      return;
    }
    try {
      const payload: any = {
        actionItemId: id,
        meetingId,
        status: val,
      };

      if (elcId) {
        payload.elcId = elcId;
      }

      await updateStatus(payload).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (e) {
      showToastNotification({
        message: (e as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  const icon = value
    ? EIconNames.CHECK_CIRCLE_OUTLINE_DONE
    : EIconNames.CHECK_CIRCLE_OUTLINE;
  const iconCursor = isLoading || actionPlanTaskId ? 'not-allowed' : 'pointer';
  const iconColor = value ? theme.colorSuccessActive : ' ';
  const tooltipTitle = value ? t('MARK_AS_INCOMPLETE') : t('MARK_AS_COMPLETED');

  return (
    <Row justify="center">
      <Tooltip title={!actionPlanTaskId ? tooltipTitle : undefined}>
        <Col
          onClick={() => onUpdateStatus(!value)}
          style={{ opacity: actionPlanTaskId ? 0.5 : 1 }}
          data-cy="meeting_task_status_toggle"
        >
          <Icon icon={icon} className={iconCursor} color={iconColor} />
        </Col>
      </Tooltip>
    </Row>
  );
};

export default ActionItemStatus;
